export const validateEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value || !emailRegex.test(value)) return false;
  return true;
};

export const validateValueLenthe = (value, minLength) => {
  if (!value || value.length < minLength) return false;
  return true;
};

export const formatPhoneFR = (raw) => {
  if (!raw) return "";
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("0") && digits.length === 10) digits = digits.slice(1);
  if (digits.length < 9) return "";
  digits = digits.slice(0, 9);
  const first = digits[0];
  const groups = digits.slice(1).match(/.{1,2}/g);
  return `+33 (0${first}) ${first} ${groups.join(" ")}`;
};

export const SafeIonIcon = ({ name }) => {
  try {
    return <ion-icon name={name}></ion-icon>;
  } catch {
    return <ion-icon name="link-outline"></ion-icon>; // fallback
  }
};

export const parseSocialMedia = (raw) => {
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};